import { hasValue } from './typeguards.utils';
export const toArray = (items) => {
    if (!hasValue(items)) {
        return [];
    }
    return Array.isArray(items) ? items : [items];
};
//# sourceMappingURL=array.utils.js.map